import React from "react";

const LogoIcon = () => {
  const imageUrl = "/assets/logo-full.jpeg";

  return (
    <div className="logo-wrapper">
      <img src={imageUrl} alt="erniee.ai" />
    </div>
  );
};

export default LogoIcon;
